import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  padding: 8rem 0;

  background-color: ${pickColor('black')};
`;

const FlexContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2.4rem;
`;

const Wrapper = styled.div`
  /* display: flex;
  flex-direction: column; */

  /* width: auto; */
  color: ${pickColor('white')};
`;

/* Technology logos come from S3 in any size and aspect ratio: each one gets the same box and is
   scaled to fit inside it, never stretched to the column width. */
const Technologies = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2.4rem;

  figure {
    width: 16rem;
    height: 10rem;
  }

  .lazy-load-image-background.lazy-load-image-loaded,
  .lazy-load-image-background.lazy-load-image-loaded img {
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: contain;
    object-position: center;
  }
`;

const TextBlock = styled.div`
  &:not(:first-of-type) {
    margin-top: 1.2rem;
  }
`;

const Title = styled(Headline)`
  margin-bottom: 3rem;
`;

export { Container, FlexContainer, Wrapper, Technologies, TextBlock, Title };
